import { render } from "./refundList.vue?vue&type=template&id=b95d154a&scoped=true"
import script from "./refundList.vue?vue&type=script&lang=js"
export * from "./refundList.vue?vue&type=script&lang=js"

import "./refundList.vue?vue&type=style&index=0&id=b95d154a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b95d154a"

export default script